import { configureStore } from "@reduxjs/toolkit";
import destinationReducer from "./destinationReducer/destinationSlice";

import offerReducer from "./offerReducer/offerSlice";
import reserveReducer from "./reserveReducer/reserveSlice";
import TourReducer from "../components/Offers/TourSlice";
import UsersReducer from "./UsersReducer/UsersSlice";
import authReducer from "./auth/authSlice";
import TourOperatorReducer from "./TourOperatorReducer/TourOperatorSlice";
import languageReducer from "./languageSlice";
import hotelReducer from "./hotelReducer/hotelSlice";
import driverReducer from "./driverReducer/driverSlice";
import tourguideReducer from "./tourguideReducer/tourguideSlice";
import leadReducer from "./leadReducer/leadSlice";
import cooperatorReducer from "./CooperatorReduser/CooperatorSlice";
import { apiSlice } from "./api/apiSlice";

const store = configureStore({
  reducer: {
    auth: authReducer,
    destination: destinationReducer,
    offer: offerReducer,
    c_tour: TourReducer,
    reservation: reserveReducer,
    user: UsersReducer,
    TourOperator: TourOperatorReducer,
    lang: languageReducer,
    hotel: hotelReducer,
    driver: driverReducer,
    tourguide: tourguideReducer,
    lead: leadReducer,
    cooperator: cooperatorReducer,

    [apiSlice.reducerPath]: apiSlice.reducer,
  },

  middleware: (getDefaultMiddleware) =>
    // === USE THE ROOT API SLICE MIDDLEWARE ===
    getDefaultMiddleware().concat(apiSlice.middleware),
});

// Note: Install React 17 packages with `npm install react@17 react-dom@17` if needed

export default store;
